module.exports = __webpack_public_path__ + "static/media/bell-beaker_MBA_wales_preview.fdb69ba6.png";